import React from 'react';
import { mockAddressDetails, mockBillingDetails, mockInvalidBillingDetails } from '../../../mocks/address.js';
import { checkIsApplePayStandardCheckout, checkIsApplePayExpressCheckout, checkIsGooglePayCheckout } from '../../../utils/paymentMethod.js';
import { fieldsetStyle } from '../styles.js';
var StubbedBillingActions = function StubbedBillingActions(_ref) {
  var onConfirm = _ref.onConfirm,
    paymentMethodType = _ref.paymentMethodType;
  var isApplePayStandardCheckout = checkIsApplePayStandardCheckout(paymentMethodType);
  var isApplePayExpressCheckout = checkIsApplePayExpressCheckout(paymentMethodType);
  var isGooglePayCheckout = checkIsGooglePayCheckout(paymentMethodType);
  return React.createElement("fieldset", {
    style: fieldsetStyle
  }, React.createElement("legend", null, "Stubbed billing address options"), isApplePayExpressCheckout && React.createElement("button", {
    onClick: function onClick() {
      return onConfirm({
        billingDetails: mockBillingDetails,
        shippingAddress: mockAddressDetails
      });
    }
  }, "Valid Address"), isGooglePayCheckout && React.createElement("button", {
    onClick: function onClick() {
      return onConfirm({
        billingDetails: mockInvalidBillingDetails
      });
    }
  }, "Invalid Billing Address"), (isApplePayStandardCheckout || isGooglePayCheckout) && React.createElement("button", {
    onClick: function onClick() {
      return onConfirm({
        billingDetails: mockBillingDetails
      });
    }
  }, "Valid Billing Address"));
};
export { StubbedBillingActions as default };